
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import Commercial from '../pages/projects/commercial/page';
import Residential from '../pages/projects/residential/page';
import Industrial from '../pages/projects/industrial/page';
import InvestorPortal from '../pages/investor-portal/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/projects/commercial',
    element: <Commercial />,
  },
  {
    path: '/projects/residential',
    element: <Residential />,
  },
  {
    path: '/projects/industrial',
    element: <Industrial />,
  },
  {
    path: '/investor-portal',
    element: <InvestorPortal />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;